interface ADACode {
  title: string;
  code: string;
  includeInOption: boolean;
}

export const adaCodes: ADACode[] = [
  {
    code: 'none',
    title: 'preview-sales-engine.static-content.copy.ADA.none',
    includeInOption: true,
  },
  {
    code: 'A5',
    title: 'preview-sales-engine.static-content.copy.ADA.tub',
    includeInOption: true,
  },
  {
    code: 'A9',
    title: 'preview-sales-engine.static-content.copy.ADA.roll-in-shower',
    includeInOption: true,
  },
  {
    code: 'G7',
    title: 'preview-sales-engine.static-content.copy.ADA.transfer-shower',
    includeInOption: true,
    //preview-sales-engine.static-content.copy.ADA.hearing
  },
  {
    code: 'B4',
    title: 'preview-sales-engine.static-content.copy.ADA.hearing',
    includeInOption: false,
  },
];

export const getADATitle = (code: string) => {
  const obj = adaCodes.filter((val, idx) => val.code === code);

  return obj[0].title;
};
